export const NOT_AVAILABLE = 'N/A'

export const formatCurrency = (value: number | null): string => {
  if (value === null) return NOT_AVAILABLE
  return `$${value.toLocaleString()}`
}

export const formatAbbreviatedCurrency = (value: number, decimals = 2): string => {
  if (value >= 1_000_000_000) return `$${(value / 1_000_000_000).toFixed(decimals)}B`
  if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(decimals)}M`
  if (value >= 1_000) return `$${(value / 1_000).toFixed(decimals)}K`
  return `$${value.toFixed(decimals)}`
}

export const formatYAxis = (value: number): string => {
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}k`
  return `${value}`
}
